import React, { useState } from 'react'
import { EnumNormalizedStructure } from 'types/enums.options'
import { useEnumOptions } from '../../../../_core/hooks'
import { ToggleButton } from 'primereact/togglebutton'
import { groupBy } from 'util/helpers.converters'
import { Card } from 'primereact/card'

type InterestInputProps = {
  value:string[]
  onChange:(_:string[]) => void
}

const InterestInput = (props:InterestInputProps) => {
  const { userInterestsData } = useEnumOptions()
  const [interest, setUserInterest] = useState<Record<string,EnumNormalizedStructure[]>>({})

  React.useEffect(() => {
    setUserInterest(groupBy<EnumNormalizedStructure & { 'category':string },'category'>(userInterestsData,'category'))
  },[userInterestsData])

  return (
    <div className="">
      <div className="justify-content-center h-100 overflow-auto mb-4">
        <p>Select up to 20 interests total, Select up to 5 from any category</p>
        {Object.keys(interest).map((x) =>
          <Card key={x} className="mb-1 justify-content-center text-center">
            <h3>{x}</h3>
            <p> {interest[x].filter(y => props.value.includes(y.id)).length}/5 </p>
            {interest[x].map(y =>
              <ToggleButton
                id={y.id}
                disabled={
                  !props.value.includes(y.id)
                  && (
                    interest[x].filter(z => props.value.includes(z.id)).length >= 5
                    || props.value.length >= 20
                  )
                }
                name={y.id}
                key={y.id}
                onChange={(e) => {
                  console.log(e)
                  const value = e.target.name
                  props.onChange(props.value.includes(value) ? props.value.filter(item => item !== value) : [...props.value,value])
                }}
                checked={props.value.includes(y.id)}
                offLabel={y.display}
                onLabel={y.display}
                value={y.id}
                className="m-1"
              />
            )}
          </Card>
        )}
      </div>
    </div>
  )
}

export default React.memo(InterestInput)
